import InfoBanner from "components/__haim/Common/InfoBanner";
import { useTranslation } from "react-i18next";
import {
  MAX_MESSAGES_IN_FREE_TRIAL,
  SUPPORT_CENTER_PHONE_NUMBER,
  SUPPORT_CENTER_PHONE_NUMBER_TEL_URL
} from "logic/Consts";
import useFirestore from "hooks/useFirestore";

export function BulkMessageDialogTrialBanner(): JSX.Element {
  const { t: translate } = useTranslation();

  const { messagesSentCount } = useFirestore();

  return (
    <InfoBanner
      title={translate("contactsPage.alert.trialVersion")}
      content={
        <>
          {translate("contactsPage.alert.bulkMessageTrialDescription", {
            maxMessageInFreeTrial: MAX_MESSAGES_IN_FREE_TRIAL,
            messageCountLeftInFreeTrial: MAX_MESSAGES_IN_FREE_TRIAL - messagesSentCount
          })}{" "}
          <a style={{ color: "blue" }} href={SUPPORT_CENTER_PHONE_NUMBER_TEL_URL}>
            {translate("contactsPage.alert.salesRepresentative", {
              supportPhoneNumber: SUPPORT_CENTER_PHONE_NUMBER
            })}
          </a>
        </>
      }
    />
  );
}
